import helpers from '@/helpers'
import { getAuth } from 'firebase/auth'
import { startOfDay } from 'date-fns'

export default {
  name: 'myreservations',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {
    user () {
      return this.$store.getters.userData
    },
    org () {
      return this.$store.getters.activeOrg;
    },
    todayReservations () {
      if(!this.user) return null
      return this.user.orgs[this.org.id]['bookings'].filter(res => {
          // takes in a date of the calendar, and determines if it's past or future
          // used to disable certain dates in the calendar
          return res.startTime === startOfDay(new Date()).getTime();
      })
    },
    upcomingReservations () {
      if(!this.user) return null
      return this.user.orgs[this.org.id]['bookings'].filter(res => {
          // takes in a date of the calendar, and determines if it's past or future
          // used to disable certain dates in the calendar
          return res.startTime > startOfDay(new Date()).getTime();
      })
    },
    pastReservations () {
      if(!this.user) return null
      return this.user.orgs[this.org.id]['bookings'].filter(res => {
          // takes in a date of the calendar, and determines if it's past or future
          // used to disable certain dates in the calendar
          return res.startTime < startOfDay(new Date()).getTime();
      })
    },
    resourceDirectory () {
      return this.$store.state.resources.boundDirectory;
    },
  },
  mounted () {

  },
  methods: {
    resourceName(booking){
      return this.resourceDirectory[booking.resourceId]['name']
    },
    formatDate(date) {
      return helpers.formatDate(date, "do MMM")
    },
    async cancelReservation(reservation) {
      console.log("cancelling reservation:", reservation);

      reservation.state = 'cancelling'

      const auth = getAuth();
      const user = auth.currentUser;
      let token = await user.getIdToken(user, true);

      let obj = {
        token: token,
        org: this.org.id,
        resource: reservation.resourceId,
        reservationId: reservation.id,
        email: this.user.email,
        uid: this.user.id,
      };

      console.log("obj to post:", obj);

      try {
        let res = await fetch("/api/cancelreservation", {
          method: "post",
          body: JSON.stringify(obj),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        res = await res.json();
        console.log("res:", res);

        if (!res.error) {
          // let store handle updating the resource with forceRefresh true
          this.$store.dispatch("updateDoc", {
            data: new helpers.Resource(res.data),
            action: "update",
            docType: "resources",
            fullDoc: true
          });

          this.$toast.success(`${this.$t('toast-Cancelled')}`);
        } else {
          throw res.message;
        }
      } catch (error) {
        console.log("error cancelling reservation:", error);
        this.$toast.error(`${this.$t('toast-Error')}` + error);
      } finally {
        // fetch the newest data from DB - necessary for error AND success
        reservation.state = null;

      }
    },
  }
}
